@if (showHeidi()) {
  <pr-ai-notes-button
    [patient]="patient()"
    (noteCreated)="noteCreated.emit($event)"
  />
}

@if (showRecord()) {
  <div class="relative inline-flex">
    @if (showMenu()) {
      <button
        mat-icon-button
        color="primary"
        type="button"
        data-testid="scribe-record-button"
        [matMenuTriggerFor]="scribeMenu"
        [matTooltip]="sessionInProgress() ? sessionInProgressLabel : menuLabel"
        [attr.aria-label]="menuLabel"
      >
        <mat-icon>mic</mat-icon>
      </button>

      <mat-menu #scribeMenu="matMenu">
        <button
          mat-menu-item
          type="button"
          data-testid="scribe-record-menu-item"
          [disabled]="sessionInProgress()"
          (click)="startRecording()"
        >
          <mat-icon>mic</mat-icon>
          <span> Record note </span>
        </button>
        <button
          mat-menu-item
          type="button"
          data-testid="scribe-view-menu-item"
          (click)="openReview()"
        >
          <mat-icon>article</mat-icon>
          <span> View notes </span>
        </button>
      </mat-menu>
    } @else {
      <span
        class="inline-flex"
        [matTooltip]="
          sessionInProgress() ? sessionInProgressLabel : 'Start recording'
        "
      >
        <button
          mat-icon-button
          color="primary"
          type="button"
          data-testid="scribe-record-button"
          aria-label="Start recording"
          [disabled]="recordDisabled()"
          (click)="startRecording()"
        >
          <mat-icon>mic</mat-icon>
        </button>
      </span>
    }

    @if (pendingNoteCount() > 0) {
      <span
        data-testid="scribe-pending-badge"
        class="bg-warn-500 pointer-events-none absolute -right-1 -top-1 flex h-5 min-w-[1.25rem] items-center justify-center rounded-full border-0 px-1 text-[11px] font-bold leading-none text-white ring-2 ring-white"
      >
        {{ pendingNoteCount() }}
      </span>
    }
  </div>
}
